import React, { FC, useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import "./menu.css";
import toVektor from "../../images/vMenu.png";
import boglanish from "../../images/boglanish.svg";
import eng from "../../images/english.svg";
import rus from "../../images/rus.svg";
import ozbek from "../../images/ozbek.svg";
import ChangeLanguage from "../../changeLanguage/ChangeLanguage";
import { useTranslation } from "react-i18next";

type Props = {
  openMenu: boolean;
  setOpenMenu: (val: boolean) => void;
};
const Menu: FC<Props> = ({ openMenu, setOpenMenu }) => {
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  const { t } = useTranslation();

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  useEffect(() => {
    if (windowSize[0] > 720) {
      setOpenMenu(false);
    }
  }, [windowSize[0]]);

  return (
    <div
      className={
        openMenu
          ? "my_response_menu_content active"
          : "my_response_menu_content"
      }
    >
      <div className="response_menu">
        <ul>
          <li>
            <Button className="nav_menu_btn" onClick={() => setOpenMenu(false)}>
              <a href="/#asosiy">
                <div> {t("NAVBARMENU.MAIN")}</div>
                <img src={toVektor} alt="vektor" />
              </a>
            </Button>
          </li>
          <li>
            <Button className="nav_menu_btn" onClick={() => setOpenMenu(false)}>
              <a href="/#imkoniyat">
                <div>{t("NAVBARMENU.CHANCES")}</div>
                <img src={toVektor} alt="vektor" />
              </a>
            </Button>
          </li>
          <li>
            <Button className="nav_menu_btn" onClick={() => setOpenMenu(false)}>
              <a href="/#product">
                <div>{t("NAVBARMENU.PRODUCT")}</div>
                <img src={toVektor} alt="vektor" />
              </a>
            </Button>
          </li>
          <li>
            <Button className="nav_menu_btn" onClick={() => setOpenMenu(false)}>
              <a href="/#about">
                <div>{t("NAVBARMENU.ABOUTUS")}</div>
                <img src={toVektor} alt="vektor" />
              </a>
            </Button>
          </li>
          <li>
            <Button className="nav_menu_btn" onClick={() => setOpenMenu(false)}>
              <a href="/#galery">
                <div>{t("NAVBARMENU.GALLERY")}</div>
                <img src={toVektor} alt="vektor" />
              </a>
            </Button>
          </li>
        </ul>

        <div className="menu_btn_content">
          <ul>
            <li className="til_btn_menu">
              <ChangeLanguage />
            </li>

            <li>
              <a href="tel:+998 99 229-20-20" className="tel_response">
                <Button className="menu_lang_button">
                  <img src={boglanish} alt="boglanish" />
                  {t("NAVBARMENU.CONTACT")}
                </Button>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Menu;
